import {
  Psychology as AiIcon,
  Analytics as AnalyticsIcon,
  SmartToy as ChatbotIcon,
  // AdminPanelSettings as AdminIcon,
  Business as CompanyIcon,
  Dashboard as DashboardIcon,
  Email as EmailIcon,
  QuestionAnswer as QnaIcon,
  CardMembership as SubscriptionIcon,
  Description as TemplateIcon,
  Face as BossBabyIcon,
  History as ChatLogIcon,
  Build as ToolIcon,
  Task as TaskIcon,
  Chat as ChatIcon,
  Compare as CompareIcon,
  Translate as TranslateIcon,
  ModelTraining as ModelIcon,
  Psychology as PromptIcon,
  Psychology as AiTestIcon,
  // Payment as PaymentIcon,
} from "@mui/icons-material";

import Router from "@/constants/router";
import { MenuDto } from "@/dto/MenuDto";
import { AdmAuth } from "./code";

export const DRAWER_WIDTH: number = 260;

export const MENU_LIST: MenuDto[] = [
  {
    title: "대시보드",
    path: Router.Dashboard,
    icon: DashboardIcon,
    auth: [AdmAuth.Admin],
  },
  {
    title: "도장 관리",
    path: Router.CompanyStamp,
    icon: CompanyIcon,
    auth: [AdmAuth.Admin],
  },
  {
    title: "구독 상품 관리",
    path: Router.Subscription,
    icon: SubscriptionIcon,
    auth: [AdmAuth.Admin],
  },
  // {
  //   title: "분할결제 설정",
  //   path: Router.InstallmentSetting,
  //   icon: PaymentIcon,
  //   auth: [AdmAuth.Admin],
  // },
  {
    title: "템플릿 관리",
    path: Router.Template,
    icon: TemplateIcon,
    auth: [AdmAuth.Admin],
  },
  {
    title: "이메일 대량 발송",
    path: Router.BulkEmail,
    icon: EmailIcon,
    auth: [AdmAuth.Admin],
  },
  {
    title: "챗봇 관리",
    icon: ChatbotIcon,
    auth: [AdmAuth.Admin],
    children: [
      {
        title: "QNA 컨텐츠 관리",
        path: Router.SuperChatContent,
        icon: QnaIcon,
        auth: [AdmAuth.Admin],
      },

      {
        title: "채팅 로그 분석",
        path: Router.SuperChatLogDashboard,
        icon: AnalyticsIcon,
        auth: [AdmAuth.Admin],
      },
    ],
  },
  {
    title: "Boss Baby 관리",
    icon: BossBabyIcon,
    auth: [AdmAuth.Admin],
    children: [
      {
        title: "프롬프트 템플릿 관리",
        path: Router.PromptTemplate,
        icon: PromptIcon,
        auth: [AdmAuth.Admin],
      },
      {
        title: "Boss Baby 채팅 로그",
        path: Router.BossBabyChatLogSessions,
        icon: ChatLogIcon,
        auth: [AdmAuth.Admin],
      },
      {
        title: "Boss Baby 도구 관리",
        path: Router.BossBabyToolList,
        icon: ToolIcon,
        auth: [AdmAuth.Admin],
      },
      {
        title: "Boss Baby 작업 관리",
        path: Router.BossBabyTaskList,
        icon: TaskIcon,
        auth: [AdmAuth.Admin],
      },
    ],
  },
  {
    title: "OCI AI 테스트",
    icon: AiTestIcon,
    auth: [AdmAuth.Admin],
    children: [
      {
        title: "AI 모델 채팅",
        path: Router.OciAiTestChat,
        icon: ChatIcon,
        auth: [AdmAuth.Admin],
      },
      {
        title: "모델 비교",
        path: Router.OciAiTestCompare,
        icon: CompareIcon,
        auth: [AdmAuth.Admin],
      },
      {
        title: "텍스트 번역",
        path: Router.OciAiTestTranslate,
        icon: TranslateIcon,
        auth: [AdmAuth.Admin],
      },
      {
        title: "모델 정보",
        path: Router.OciAiTestModels,
        icon: ModelIcon,
        auth: [AdmAuth.Admin],
      },
    ],
  },
  {
    title: "AI Manager",
    path: Router.AiManager,
    icon: AiIcon,
    auth: [AdmAuth.Admin],
  },
];
